/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import toast, {Toaster} from "react-hot-toast";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import Pagination from "../../../Components/Common/Pagination";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import * as XLSX from "xlsx";
import SchoolContext from "../../../Context/SchoolContext";
import AuthumSearchForm from "../../../Components/Common/AuthumSearchForm";
import PrintFilterForm3 from "../../../Components/Students/AdminProfile/PrintFilterForm3";

function NoPrintStudentsPage() {

  
    const [modal, setModal] = useStateCallback(false);
    const [noPrintList, setNoPrintList] = useState([]);
    const [printableList, setPrintableList] = useState([]);
    const {schoolList} = useContext(SchoolContext); 
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState("");
    const [loading2, setLoading2] = useState(false);
  
    const [first, setFirst] = useState("");

    // track whether the search has been performed so we can show results card
    const [showResults, setShowResults] = useState(false);

    const searchStudentList = async (e) => {
        if (e) {
        e.preventDefault();
        }
        if(school.length > 0){
            setLoading2(true);
            const server_response = await ajaxStudent.searchAllNoPrintStudents(page, school, query);
            setLoading2(false);
            // indicate that a search has been executed so the results card can render
            setShowResults(true);
            if (server_response.status === "OK") {
                setFirst(server_response.details.meta.offset);
                setMeta(server_response.details.meta.totalPages);
                setNoPrintList(server_response.details.list || []);
            } else {
                setNoPrintList([]);
            }
        }
        else {
                toast.error("Please select a school!");
        } 
    };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };
  
  useEffect(() => {
    if (query || school) {
      searchStudentList();
    }
  }, [page]);

  const setStudents = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setNoPrintList([]);
    // hide results card until another search is made
    setShowResults(false);
  };

  const refreshData = () => {
    setNoPrintList([]);
  };

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <PrintFilterForm3
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };

  const exportToExcel = (data) => {
        const worksheetData = (data || []).map((item) => ({
          "Names": item.full_name,
          "School": item.school,
          "Student Class": item.class,
          "Pocket Money": item.pocket_money_balance <= 0 ?"NIL":"AVAILABLE"
         }));
      
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Student List (No Prints)");
      
        XLSX.writeFile(workbook, "no_print_student_list.xlsx");
  };

  
  return (
    <AppContainer title="Students Without Fingerprints">
            <Toaster position="top-center" reverseOrder={false} />
            {modal}
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="card custom-card" style={{ borderRadius: "10px" }}>
                        <div className="card-body">
                            <div>
                                <h5 style={{ marginBottom: 0 }} className="card-title">
                                Search Filters
                                </h5>
                                
                                
                            </div>
                            <AuthumSearchForm school={school} student={query} setSchool={setSchool} setStudent={setQuery}
                            searchStudents={searchStudentList} resetSearch={setStudents} schoolList={schoolList}/>
                        </div> 
                    </div>
                </div>

                <div className="col-lg-12 col-md-12">
                  {loading2 && showResults && (
                      <div className="card custom-card" style={{ borderRadius: "10px" }}>
                        <div className="card-body">
                          <div style={{ textAlign: "center" }}>
                            <Loader />
                          </div>
                        </div>
                      </div>
                    )}
                          {showResults && noPrintList === false && (
                            <div className="card custom-card" style={{ borderRadius: "10px" }}>
                              <div className="card-body">
                                <div>
                                  <p style={{ textAlign: "center" }}>
                                    No matching students found.<br/> <Link onClick={handleModal} className="btn btn-primary mr-3"><i className="far fa-plus mr-1"></i>Add New Student</Link>
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                          {showResults && noPrintList && (
                            <div className="card custom-card" style={{ borderRadius: "10px" }}>
                              <div className="card-body map-card">
                                <div class="heading-layout1 mg-b-25">
                            <TableHeader
                                title="Students Without Fingerprints"
                                subtitle="List of all the students with no fingerprints enrolled sorted in ascending order"
                            />
                            <div class="dropdown">
                                <Link class="dropdown-toggle"  role="button" data-toggle="dropdown" aria-expanded="false">...</Link>

                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={handleModal} ><i class="fas fa-file-export"></i>Export</Link>
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link> 
                                </div>
                            </div>
                        </div>
                                <div className="table-responsive">
                                    {loading2 ? (
                                        <Loader />
                                    ) : (
                                        <table className="table display data-table text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Name</th>
                                            <th>School</th>
                                            <th>Class</th>
                                            <th>Pocket Money</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {noPrintList.length > 0 ? (
                                            noPrintList.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{width:"5px"}}>{index + first + 1}</td>

                                                <td><Link to={`/students/profile/${item.student_id}/${item.user_id}`}>
                                                                                                    {item.full_name}
                                                                                                    </Link></td>
                                                <td className="text-dark">{item.school}</td>
                                                <td className="text-dark">{item.class}</td>
                                                <td>
                                  {item.pm_balance <= 0 ? (
                                    <span className="badge badge-danger">NIL</span>
                                  ) : (
                                    <span className="badge badge-success">AVAILABLE</span>
                                  )}
                                </td>
                                               
                                            </tr>
                                            ))
                                        ) : 
                                        (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                    No students registered yet.
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                        </table>
                                    )}
                                    
                                  
                                </div>
                        <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                                </div>
                             
                            </div>
                          )}
                          
                        </div>
                 
            </div>
        
    </AppContainer>
  );
}

export default NoPrintStudentsPage;